export const configDefault = {
    timings: {
        applicationChangeDelay: 400,
        inputChangeDelay: 300,
        calculateAllTimeout: 500,
        calculationControlDebounce: 300
    },
    tests: {
        timings: {
            applicationChangeDelay: 401,
            calculationControlDebounce: 301,
            inputChangeDelay: 300,
        },
    }
}
